import { useEffect, useState } from "react";
import { FaDiscord } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { star } from "../Assets";
import { menuItems } from "./Navbar"; // Adjust the path if needed

const currentYear = new Date().getFullYear();

const Footer = () => {
  const [activeSection, setActiveSection] = useState("Home");

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      const sectionOffsets = {
        Home: 0,
        About: document.getElementById("about")?.offsetTop || 0,
        Team: document.getElementById("team")?.offsetTop || 0,
        Roadmap: document.getElementById("roadmap")?.offsetTop || 0,
      };

      const current = Object.keys(sectionOffsets).findLast((key) =>
        scrollPosition >= sectionOffsets[key] - 100
      );

      if (current) setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <footer className="bg-[#159BFB] text-white py-16 px-6 sm:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-12">
        {/* Column 1 */}
        <div className="md:col-span-3 space-y-6">
          <h2 className="text-3xl sm:text-4xl font-bold">PopyourBubbles</h2>
          <p className="">
            one bubble at a time, we're reshaping reality.
          </p>

          {/* Social Icons */}
          <div className="flex gap-4 text-2xl">
            <a href="https://x.com/popyourbubbles" target="_blank" rel="noopener noreferrer">
              <FaXTwitter className="hover:text-black transition-colors" />
            </a>
            <a href="https://discord.gg/hUMBpwXxTq" target="_blank" rel="noopener noreferrer">
              <FaDiscord className="hover:text-black transition-colors" />
            </a>
          </div>

          {/* Copyright */}
          {/* <p className=" mt-4">
            © {currentYear} PopyourBubbles. All rights reserved.
          </p> */}
        </div>

        {/* Column 2 - Sitemap */}
        <div className="space-y-4">
          <h3 className="text-lg font-semibold">Sitemap</h3>
          <ul className="space-y-2 ">
            {menuItems.map((item) => (
              <li key={item.id}>
                <a
                  href={item.link}
                  className={`hover:underline ${
                    activeSection === item.label ? "text-[#313131]" : "text-white"
                  }`}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 3 - Terms & Star */}
        <div className="space-y-4 flex flex-col justify-between">
          <div>
               <p className=" text-sm">
            © {currentYear} PopyourBubbles. All rights reserved.
          </p>
          </div>
          <img src={star} alt="Star Icon" className="w-24 mt-8" />
        </div>
        {/* <div className="space-y-4 flex flex-col justify-between">
          <div>
            <h3 className="text-lg font-semibold">Terms and Policy</h3>
            <ul className="space-y-2  mt-2">
              <li>
                <a href="/privacy-policy" className="hover:underline">Privacy Policy</a>
              </li>
              <li>
                <a href="/privacy-policy" className="hover:underline">Terms & Conditions</a>
              </li>
            </ul>
          </div>
          <img src={star} alt="Star Icon" className="w-24 mt-8" />
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;